import { RRDate, Service } from '@raskrask-dk/raskrask-utils'
import { PartnerBF } from '.'

interface ServiceBFConstructor {
    icon?: string
    text?: string
}

export class ServiceBF extends Service {
    icon?: string
    text?: string

    constructor(service: Service, { icon, text }: ServiceBFConstructor) {
        super(
            service.id,
            service.name,
            service.duration.toMillis() / 60 / 1000,
            service.freeConsultation
        )
        this.icon = icon
        this.text = text
    }

    public getPartnersBy(date?: RRDate | undefined): PartnerBF[] {
        return super.getPartnersBy(date) as PartnerBF[]
    }

    public get hours(): number {
        return this.duration.hours
    }

    public get isActive(): boolean {
        return !this.isDisabled
    }

    public get t() {
        return {
            hours: `count: ${this.hours}`,
        }
    }
}
